module.exports = __webpack_public_path__ + "static/img/10-周大福.1ff94e89.png";